import { connect } from 'react-redux';

import chargesActionCreators from '_store/_actions/charges';

import ChargeDetails from './ChargeDetails';

const mapDispatchToProps = {
  onFetchChargeById: chargesActionCreators.fetchChargeById,
  onFetchPublicChargeById: chargesActionCreators.fetchPublicChargeById,
};

export default connect(null, mapDispatchToProps)(ChargeDetails);
